export default (device) => ({
  jid: device.txt.id,
  name: device.txt.name,
  code: device.txt.code,
  familyName: device.txt.familyname
});
